<template>
  <v-row>
    <v-col>
      <SurgeryDetail :surgery="surgery" />

      <Allergy
        :attendance="attendance"
        :showForm="!disabled"
        :allowDelete="!disabled"
      />

      <MedicationHistory
        :attendance="attendance"
        :showForm="!disabled"
        :allowDelete="!disabled"
      />

      <v-row dense>
        <v-col class="text-h5 gray--text"> Questionário </v-col>
      </v-row>

      <v-row align="end">
        <v-col cols="2">
          <v-row dense>
            <v-col> Paciente em jejum </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-radio-group
                v-model="fasting"
                row
                mandatory
                dense
                hide-details
                class="mt-0"
                @change="changeFasting"
                :disabled="disabled"
              >
                <v-radio label="Sim" :value="true" />
                <v-radio label="Não" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="2">
          <v-text-field
            label="Tempo"
            v-model="fastingTime"
            dense
            hide-details
            outlined
            background-color="white"
            :disabled="!fasting || disabled"
            @change="debouncedSave"
          />
        </v-col>

        <v-col cols="3">
          <v-row dense>
            <v-col> Hipertensão arterial sistemica </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-radio-group
                v-model="hypertension"
                row
                mandatory
                dense
                hide-details
                class="mt-0"
                @change="debouncedSave"
                :disabled="disabled"
              >
                <v-radio label="Sim" :value="true" />
                <v-radio label="Não" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="2">
          <v-row dense>
            <v-col> Diabetes </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-radio-group
                v-model="diabetes"
                row
                mandatory
                dense
                hide-details
                class="mt-0"
                @change="debouncedSave"
                :disabled="disabled"
              >
                <v-radio label="Sim" :value="true" />
                <v-radio label="Não" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-row dense>
            <v-col> Retirado prótese </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-radio-group
                v-model="prosthesisRemoved"
                row
                mandatory
                dense
                hide-details
                class="mt-0"
                @change="debouncedSave"
                :disabled="disabled"
              >
                <v-radio label="Sim" :value="true" />
                <v-radio label="Não" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="2">
          <v-row dense>
            <v-col> Acesso venoso periférico </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-radio-group
                v-model="venousAccess"
                row
                mandatory
                dense
                hide-details
                class="mt-0"
                @change="changeVenousAccess"
                :disabled="disabled"
              >
                <v-radio label="Sim" :value="true" />
                <v-radio label="Não" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="3">
          <v-row dense>
            <v-col> Membro </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-combobox
                v-model="venousAccessSite"
                row
                dense
                hide-details
                outlined
                :disabled="!venousAccess || disabled"
                @change="debouncedSave"
                :items="venousAccessSites"
                background-color="white"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="auto">
          <v-row dense>
            <v-col> Infecção </v-col>
          </v-row>

          <v-row dense>
            <v-col>
              <v-radio-group
                v-model="infection"
                row
                mandatory
                dense
                hide-details
                class="mt-0"
                @change="debouncedSave"
                :disabled="disabled"
              >
                <v-radio label="Sim" :value="true" />
                <v-radio label="Não" :value="false" />
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-textarea
            label="Notas"
            v-model="observation"
            placeholder=" "
            hide-details
            outlined
            background-color="white"
            @change="debouncedSave"
            :disabled="disabled"
          />
        </v-col>
      </v-row>

      <SurgeryVitalMeasurementList
        :surgery="surgery"
        :refreshSurgery="refreshSurgery"
        :surgeryMoment="surgeryMoment"
        :disabled="disabled"
      />

      <SurgeryTherapyList
        :surgery="surgery"
        :refreshSurgery="refreshSurgery"
        :surgeryMoment="surgeryMoment"
        :disabled="disabled"
      />

      <v-row dense>
        <v-col class="text-h5 gray--text"> Anexos </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <FileUpload
            ownerType="Surgery::Preoperative"
            :ownerId="surgery.preoperative.id"
            :disabled="disabled"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Allergy from "@/components/medical_record/hpp/allergy.vue";
import MedicationHistory from "@/components/medical_record/hpp/medication_history.vue";
import SurgeryDetail from "@/components/surgery/detail.vue";
import SurgeryVitalMeasurementList from "@/components/surgery/vital_measurement/list/index.vue";
import SurgeryTherapyList from "@/components/surgery/therapy/list/index.vue";

export default {
  name: "SurgeryPreoperative",
  props: {
    surgery: Object,
    refreshSurgery: Function,
    setSurgeryMoment: Function,
    surgeryMoment: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Allergy,
    MedicationHistory,
    SurgeryDetail,
    SurgeryVitalMeasurementList,
    SurgeryTherapyList,
  },
  data() {
    return {
      fasting: false,
      fastingTime: "",
      hypertension: false,
      diabetes: false,
      prosthesisRemoved: false,
      venousAccess: false,
      venousAccessSite: "",
      infection: false,
      observation: "",
      venousAccessSites: [
        "Superior direito",
        "Superior esquerdo",
        "Inferior direito",
        "Inferior esquerdo",
      ],
    };
  },
  created() {
    this.debouncedSave = this.lodash.debounce(
      this.saveSurgeryPreoperative,
      2000
    );
  },
  mounted() {
    this.fasting = this.surgery.preoperative.fasting;
    this.fastingTime = this.surgery.preoperative.fastingTime;
    this.hypertension = this.surgery.preoperative.hypertension;
    this.diabetes = this.surgery.preoperative.diabetes;
    this.prosthesisRemoved = this.surgery.preoperative.prosthesisRemoved;
    this.venousAccess = this.surgery.preoperative.venousAccess;
    this.venousAccessSite = this.surgery.preoperative.venousAccessSite;
    this.infection = this.surgery.preoperative.infection;
    this.observation = this.surgery.preoperative.observation;

    this.setSurgeryMoment("preoperative");
  },
  computed: {
    attendance() {
      return this.surgery.attendance;
    },
  },
  methods: {
    changeFasting() {
      if (!this.fasting) {
        this.fastingTime = "";
      }

      this.debouncedSave();
    },
    changeVenousAccess() {
      if (!this.venousAccess) {
        this.venousAccessSite = "";
      }

      this.debouncedSave();
    },
    saveSurgeryPreoperative() {
      return this.apolloMutate({
        mutation: require("@/graphql/surgery/save_surgery_preoperative.gql"),
        variables: {
          surgeryId: this.surgery.id,
          fasting: this.fasting,
          fastingTime: this.fastingTime,
          hypertension: this.hypertension,
          diabetes: this.diabetes,
          prosthesisRemoved: this.prosthesisRemoved,
          venousAccess: this.venousAccess,
          venousAccessSite: this.venousAccessSite,
          infection: this.infection,
          observation: this.observation,
        },
      }).then(() => {
        this.refreshSurgery();
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
